import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import {
    nearbyStoreSelector,
    preferredLocationSelector,
} from "tsi-common-react/src/apps/common/selectors";
import { useAppSelector } from "tsi-common-react/src/apps/reducers";
import { Link } from "tsi-common-react/src/common/Link";
import { BreakPoint } from "tsi-common-react/src/models/screen.interfaces";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { c } from "ttag";

import iconStoreLocatorFooter from "../../svg/store_locator_footer.svg";

interface IProps {
    isSiteSearchOpen: boolean;
}

export const NearbyStoresSearch = (props: IProps): React.ReactNode => {
    const viewport = useAppSelector((state) => state.common.viewport);
    const numStores = useAppSelector(
        (state) => nearbyStoreSelector(state).length,
    );
    const location = useAppSelector((state) =>
        preferredLocationSelector(state),
    );
    const linkHref = usePageURL("find_a_retailer");

    const wrapperClasses = classNames({
        "search-nav__retailers": true,
        "search-nav__retailers--hide": props.isSiteSearchOpen,
        "al-search-nav__link--find-a-retailer": true,
    });
    const shouldDisplayStores =
        numStores > 0 && viewport.width > BreakPoint.MEDIUM;
    if (!shouldDisplayStores) {
        return <span>{c("NearbyStoresSearch").t`Find a Retailer`}</span>;
    }
    const locationLabel = location ? location.formatted_address : "";
    const userLocation = (
        <span className="search-nav__retailers--location" key="user-loc">
            {/* translator: fallback location: N (store|stores) near you. */}
            {locationLabel || c("NearbyStoresSearch").t`you`}
        </span>
    );
    return (
        <Link
            href={linkHref}
            title={c("NearbyStoresSearch").t`Find A Retailer Near You`}
            className={wrapperClasses}
        >
            <SVG
                className="search-nav__retailers-icon search-nav__retailers-icon--desktop"
                src={iconStoreLocatorFooter}
                title={c("NearbyStoresSearch").t`Locate a Store Icon`}
            />
            <span className="search-nav__retailers--content">
                {numStores === 1
                    ? c("NearbyStoresSearch")
                          .jt`${numStores} store near ${userLocation}`
                    : c("NearbyStoresSearch")
                          .jt`${numStores} stores near ${userLocation}`}
            </span>
        </Link>
    );
};
